import React, { useState } from 'react';

import PropTypes from 'prop-types';
import MdCake from 'react-icons/lib/md/cake';

import Link from 'wanderu-component-react-router-link';
import {
    ElementQuery,
    Layout,
    MarkdownContent,
    Notification,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './GlobalSiteBanner.scss';

const propTypes = {
    message: PropTypes.node.isRequired,
    onDismiss: PropTypes.func,
    t: PropTypes.func,
    type: PropTypes.string.isRequired,
    url: PropTypes.string,
};

function GlobalSiteBanner(props) {
    const {
        message,
        onDismiss,
        t,
        type,
        url,
    } = props;

    const [height, setHeight] = useState(null);

    const onDimensionsChange = (dimensions) => {
        const { height: nextHeight } = dimensions;

        if (height === nextHeight) {
            return;
        }

        document.documentElement.style.setProperty(
            '--site-banner-height',
            `${nextHeight}px`,
        );
        setHeight(nextHeight);
    };

    return (
        <section
            className={styles.root}
        >
            <div className={styles.globalBanner}>
                <ElementQuery
                    onChange={onDimensionsChange}
                    passAsProps={false}
                    dimensionsOnly
                >
                    <Notification
                        onDismiss={onDismiss}
                        type={type}
                    >
                        <Layout className={styles.globalBannerContent}>
                            <MdCake className={styles.bannerIcon} />

                            <MarkdownContent aria-hidden="true">
                                {t(message)}
                            </MarkdownContent>

                            {url && (
                                <Link
                                    className={styles.link}
                                    href={url}
                                    target="_blank"
                                >
                                    <span aria-label={t(message)}>
                                        {t('see-details')}
                                        &nbsp;&rsaquo;
                                    </span>
                                </Link>
                            )}
                        </Layout>
                    </Notification>
                </ElementQuery>
            </div>
        </section>
    );
}

GlobalSiteBanner.propTypes = propTypes;

export { GlobalSiteBanner };
export default localize(GlobalSiteBanner, 'baseApp');
